import { CopyIconItemProps } from '@raisin/components-lib';

export const parseToCopyIconItem =
  (allItemsHasIcon: boolean) =>
  (item: CopyIconItemProps): CopyIconItemProps => {
    if (allItemsHasIcon) {
      return {
        body: item.body,
        title: item.title,
        icon: item.icon,
      };
    }
    return {
      body: item.body,
      title: item.title,
      icon: [],
    };
  };
